/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ReleaseAccessListOperationEnum } from './releaseAccessListOperationEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseAccessListSpec { 
    /**
     * List of org ids having access to release
     */
    access_list: Array<string>;
    operation: ReleaseAccessListOperationEnum;
    release_type: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    cloud_provider?: CloudProviderEnum;
    /**
     * Version String for a release
     */
    version: string;
}
export namespace UpdateReleaseAccessListSpec {
}


